module.exports = __webpack_public_path__ + "files/7912627858eedd14767a72e42547b589.png";